import { Icon } from "@iconify/react";
import { LoginBox } from "../components/loginBox";
import { Header1 } from "../components/headers";
import userBrowserLanguage from "../components/userBrowserLanguage";
import getTranslationJson from "../components/getTranslationJson";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios, { AxiosError, type AxiosResponse } from "axios";
import userTimeZoneCountryCode from "../components/userTimeZoneCountryCode";
import { useState } from "react";
import { useParams } from "react-router";
import React from "react";

function BrushingReportFeedback() {
  const { feedback_code, feedback_value } = useParams();
  const translation = getTranslationJson(userBrowserLanguage());
  const countryCode = userTimeZoneCountryCode();

  const queryClient = useQueryClient();

  const [errorNotification, setErrorNotification] = useState("");
  const [email, setEmail] = useState("");

  // Mutations
  const mutationBrushingReportFeedback = useMutation({
    mutationKey: ["brushing_report_feedback"],
    mutationFn: async (): Promise<AxiosResponse> => {
      return axios.get(
        import.meta.env.VITE_PUBLIC_PLATFORM_BACKEND_API_URL! + "/yotdfeedback/" + feedback_code + "/" + feedback_value,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
    },
    onSuccess: (data: AxiosResponse) => {
      // Invalidate and refetch
      queryClient.invalidateQueries({ queryKey: ["brushing_report_feedback"] });
      setEmail(data.data.email);
    },
    onError: (data: AxiosError) => {
      // Invalidate and refetch
      console.error("Login error:", data);
      if (data.status === 400) {
        setErrorNotification(translation.feedback_value_invalid || "Invalid feedback value");
      } else {
        setErrorNotification(data.message || "An error occurred while logging in.");
      }
    },
  });
  React.useEffect(() => {
    verifyEmailHandleSubmit();
  }, []);

  const verifyEmailHandleSubmit = () => {
    if (import.meta.env.VITE_PUBLIC_DEV === "true") {
      console.log("Time Zone Country Code:", countryCode);
      console.log("Browser Language:", userBrowserLanguage());
    }
    mutationBrushingReportFeedback.mutate();
  };

  return (
    <div className="font-inter-24">
      <LoginBox>
        <header className="fflex flex-col mb-6 items-center justify-center">
          <Header1>{translation.feedback || "Feedback"}</Header1>
        </header>
        {mutationBrushingReportFeedback.isError && (
          <>
            <div className="flex items-center justify-center">
              <Icon icon="prime:times" className=" text-7xl text-rose-600 bg-rose-50 rounded-[40px] mb-2 p-3" />
            </div>
            <div className="my-5 text-sm text-rose-600 bg-rose-50 py-3 px-4 rounded-md font-medium">
              {errorNotification || "An error occurred while processing your request."}
            </div>
          </>
        )}
        {mutationBrushingReportFeedback.isSuccess && (
          <>
            <div className="flex items-center justify-center">
              <img
                className="feedback_icon w-30"
                src="https://playbrush-assets.s3.eu-west-1.amazonaws.com/YearOfTheDragon/icon_feedback_thank_you.png"
                alt="confetti emoji"
              />
            </div>
            <div className="my-5 text-sm text-brand-green bg-green-50 py-3 px-4 rounded-md font-medium text-center">
              {translation.thank_you_for_your_feedback || "Thank you for your feedback!"}
              <div>{email}</div>
            </div>
          </>
        )}
        {mutationBrushingReportFeedback.isPending && (
          <div className="flex items-center justify-center">
            <Icon icon="mdi:loading" className="animate-spin text-6xl text-brand-green" />
          </div>
        )}
      </LoginBox>
    </div>
  );
}
export default BrushingReportFeedback;
